import React, { useContext } from 'react';

import _get from 'lodash/get';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Icon } from 'components/modules/foundation/components';
import { selectBusinessName } from 'selectors/business';

import MainNavigationDropdown from './MainNavigationDropdown';
import Routing from '../../../../libs/routing';
import { PreviewWebsiteButton } from '../../../modules/buttons/components';
import { FrontChat } from '../../../modules/chat';
import NavigationContext from '../../../routes/DashboardRoute/DashboardRoute.context';

import '../../../../styles/core/components/main-navigation.scss';

function MainNavigation({ website }) {
  const { setShowMobileNavigation } = useContext(NavigationContext);

  const businessName = useSelector(selectBusinessName);

  return (
    <div className="main-navigation">
      <FrontChat />
      <div className="mobile-navigation-icon-container">
        <Icon
          name="angle right"
          size="big"
          onClick={() => {
            setShowMobileNavigation(true);
          }}
        />
      </div>
      <div className="left-side-container">
        <Link to="/" className="go-back" role="button" aria-label="Go back">
          <Icon name="arrow-left" />
        </Link>
        <Link to={`${Routing.getHomeUrl(website)}`} className="business-name">
          {businessName}
        </Link>
      </div>
      <PreviewWebsiteButton />
      <MainNavigationDropdown />
    </div>
  );
}

const mapStateToProps = (state) => ({
  website: _get(state, 'business.core.value.website'),
});

export default connect(mapStateToProps)(MainNavigation);
